import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PrefixUrlPipe } from '../../pipes/prefix-url.pipe';

export type EventqActionLoaderFill = 'viewport' | 'panel';

/** Matches `eventq-action-loader-pulse` (2s) in action-loader.scss. */
const PULSE_PERIOD_MS = 2000;

@Component({
  selector: 'eventq-action-loader',
  imports: [PrefixUrlPipe],
  templateUrl: './action-loader.html',
  styleUrl: './action-loader.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqActionLoader {
  readonly message = input.required<string>();
  readonly emblemSrc = input('/assets/events/ecam-emblem.svg');
  /** When true (default), emblem pulses for loading. Set false for static empty states. */
  readonly pulsing = input(true);
  /**
   * Layout fill mode.
   * - `viewport` (default): tall min-height for full-page / AgentUI empty states.
   * - `panel`: fill the flex host (Resolve workspace) with Figma H5 white message.
   */
  readonly fill = input<EventqActionLoaderFill>('viewport');

  /**
   * Negative delay captured once so this emblem joins the shared pulse phase.
   * A later instance uses the same clock, so replacing one loader with another
   * continues the cycle instead of restarting it.
   */
  readonly pulseDelay = `-${performance.now() % PULSE_PERIOD_MS}ms`;
}
